"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isScrollTopOrBottomAnchor = exports.isSamePageAnchorUrl = exports.isPageUrl = exports.isAbsoluteUrl = exports.isDocumentUrl = exports.isMailtoUrl = exports.isWhatsappLink = exports.isPhoneUrl = exports.LEGACY_DOCUMENT_URL_REGEXP = exports.DOCUMENT_URL_REGEXP = exports.ABSOLUTE_URL_REGEXP = exports.SAME_PAGE_WITH_ANCHOR_REGEXP = exports.PAGE_URL_REGEXP = exports.WHATSAPP_LINK_PREFIX = exports.PHONE_URL_REGEXP = exports.MAILTO_URL_REGEXP = void 0;
exports.MAILTO_URL_REGEXP = /mailto:([^?]+)(\?(.*))?/;
exports.PHONE_URL_REGEXP = /^tel:(.*)/;
exports.WHATSAPP_LINK_PREFIX = `https://api.whatsapp.com/send?phone=`;
exports.PAGE_URL_REGEXP = /^\/([^ ?#]*)?[#]?([^ ?#]*)[?]?(.*)/;
exports.SAME_PAGE_WITH_ANCHOR_REGEXP = /^#([^ ?]*)[?]?(.*)/;
exports.ABSOLUTE_URL_REGEXP = /^(http|https):\/\/(.*)/;
exports.DOCUMENT_URL_REGEXP = /^wix:document:\/\/v1\/(.+)\/(.+)/;
exports.LEGACY_DOCUMENT_URL_REGEXP = /^document:\/\/(.*)/;
const isPhoneUrl = (url) => exports.PHONE_URL_REGEXP.test(url);
exports.isPhoneUrl = isPhoneUrl;
const isWhatsappLink = (url) => url.startsWith(exports.WHATSAPP_LINK_PREFIX);
exports.isWhatsappLink = isWhatsappLink;
const isMailtoUrl = (url) => exports.MAILTO_URL_REGEXP.test(url);
exports.isMailtoUrl = isMailtoUrl;
const isDocumentUrl = (url) => exports.DOCUMENT_URL_REGEXP.test(url) || exports.LEGACY_DOCUMENT_URL_REGEXP.test(url);
exports.isDocumentUrl = isDocumentUrl;
const isAbsoluteUrl = (url) => exports.ABSOLUTE_URL_REGEXP.test(url);
exports.isAbsoluteUrl = isAbsoluteUrl;
const isPageUrl = (href) => exports.PAGE_URL_REGEXP.test(href);
exports.isPageUrl = isPageUrl;
const isSamePageAnchorUrl = (href) => exports.SAME_PAGE_WITH_ANCHOR_REGEXP.test(href);
exports.isSamePageAnchorUrl = isSamePageAnchorUrl;
const isScrollTopOrBottomAnchor = (anchorDataId) => ['SCROLL_TO_TOP', 'SCROLL_TO_BOTTOM'].includes(anchorDataId);
exports.isScrollTopOrBottomAnchor = isScrollTopOrBottomAnchor;
//# sourceMappingURL=linkPatternUtils.js.map